module.exports = __webpack_public_path__ + "img/ARG.a4681270.svg";